// Swiper Initialization
document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.heroSwiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        speed: 1000,
        
        // Navigation arrows
        navigation: {
            nextEl: '.heroSwiper-button-next',
            prevEl: '.heroSwiper-button-prev',
        },
        
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 1,
                spaceBetween: 0
            }
        }
    });
});